import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';
import { DISASTER_TYPE_LIST, DISASTER_YEARLIST } from '../disaster-monitoring-map/disaster-monitoring-map-constants';

@Component({
  selector: 'app-disaster-monitoring-sidebar',
  templateUrl: './disaster-monitoring-sidebar.component.html',
  styleUrls: ['./disaster-monitoring-sidebar.component.scss']
})
export class DisasterMonitoringSidebarComponent implements OnInit {

  disasterList:any = []
  sourceList: any = [
    { key: 'AI Hazard Monitoring', value: 'AGENTIC_HAZARD' },
    { key: 'EM-DAT', value: 'EM_DAT' },
    // { key: 'WEB AGENT', value: 'WEB_AGENT' }
  ]
  yearList: any = []
  stateList: any = [{ key: 'Andhra Pradesh', value: 'cdf94322-30bf-456b-b0c6-b4038caebd6a' }]
  selectedYear: any = 'ALL'
  selectedStartDate: any = '2017'
  selectedEndDate: any = '2025'
  selectedState: any = ''
  selectedDistrict: any = ''
  selectedMandal: any = ''
  queryParams: any = {};
  isInitialLoad: boolean = false;
  selectedDisasterType: any = 'Flood'
  selectedSourceType: any;
  locType: any = 'COUNTRY';
  isDistrictChecked: boolean = true;

  constructor(private route: ActivatedRoute, private router: Router, private gisUtils: UtilsService) {
    this.isInitialLoad = true;
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params: Params) => {
      this.queryParams = params;
      if (!params || Object.keys(params).length === 0) {
        this.selectedDisasterType = 'Cyclone';
        this.selectedSourceType = 'AGENTIC_HAZARD';
        this.selectedYear = 'ALL';
        this.selectedStartDate = '2017';
        this.selectedEndDate = '2025';
        this.onDisasterTypeSelect();
        this.onSubmit();
      } else {
        this.selectedState = params['location'] && params['location'].split('&')[1] ? params['location'].split('&')[1] : '';
        let source = params['source'];
        if (source === 'EM-DAT') {
          source = 'EM_DAT';
        }
        this.selectedSourceType = source || 'AGENTIC_HAZARD';

        this.selectedDisasterType = params['disasterType'] || (this.selectedSourceType === 'AGENTIC_HAZARD' ? 'Cyclone' : 'Flood');
        this.selectedYear = params['year'] || 'ALL';
        this.selectedStartDate = params['startDate'] || (this.selectedSourceType === 'AGENTIC_HAZARD' && this.selectedDisasterType === 'Land Slide' ? '2013' : '2017');
        this.selectedEndDate = params['endDate'] || (this.selectedSourceType === 'AGENTIC_HAZARD' && this.selectedDisasterType === 'Land Slide' ? '2016' : '2025');
      }

      this.disasterList = DISASTER_TYPE_LIST[this.selectedSourceType];
      this.filterYearList();

      if (!isNullOrUndefined(this.queryParams) && Object.keys(this.queryParams).length > 0) {
        this.requestSelectedFilterParams();
      }
    });
  }

  onSubmit() {
    let options = { ...this.queryParams }
    options['year'] = this.selectedYear
    options['disasterType'] = this.selectedDisasterType
    options['source'] = this.selectedSourceType
    if (this.selectedSourceType === 'AGENTIC_HAZARD' && (this.selectedDisasterType === 'Cyclone' || this.selectedDisasterType === 'Land Slide')) {
      options['startDate'] = this.selectedStartDate;
      options['endDate'] = this.selectedEndDate;
      options['year'] = this.selectedStartDate === this.selectedEndDate ? this.selectedStartDate : 'ALL';
    }

    // options['locType'] = this.locType
    // if (this.locType == 'STATE') {
    //   options['pUUID'] = this.selectedState.split('##')[1]
    //   options['locName'] = this.selectedState.split('##')[0]
    //   const locationInfo = this.selectedState
    //   options['location'] += '&' + locationInfo
    // }
    this.router.navigate(['.'], {
      relativeTo: this.route,
      queryParams: options,
      queryParamsHandling: 'merge'
    })
  }

  requestSelectedFilterParams() {
    let currentUrlParams: any = {};
    // if (!this.isInitialLoad) {
    //   currentUrlParams = this.selectedParams;
    // }
    currentUrlParams['component'] = 'DISASTERMONITORING';
    currentUrlParams['src'] = 'IMD_GRID'
    if (this.isInitialLoad) {
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['view'] = 'ADMIN';
      currentUrlParams['pType'] = 'COUNTRY';
      currentUrlParams['cType'] = 'STATE';
      currentUrlParams['parentLoc'] = 'COUNTRY';
      currentUrlParams['dashboardView'] = 'INDIA';
      this.gisUtils.selectedParams.next(currentUrlParams);
      this.isInitialLoad = false
    }
  }
  toggleDistrictLayer(event) {
    const checkbox = event.target as HTMLInputElement;
    this.isDistrictChecked = checkbox.checked;
    this.gisUtils.disasterMonitoringDistrictLayerToggle.next(this.isDistrictChecked);
  }

  onSourceSelect() {
    this.disasterList = DISASTER_TYPE_LIST[this.selectedSourceType]
    this.filterYearList();
    this.selectedDisasterType = this.selectedSourceType === 'AGENTIC_HAZARD' ? 'Cyclone' : 'Flood'
    this.selectedYear = 'ALL'
    this.onDisasterTypeSelect();
  }
  onDisasterTypeSelect() {
    this.filterYearList();
    if (this.selectedSourceType === 'AGENTIC_HAZARD') {
      this.selectedStartDate = this.selectedDisasterType === 'Land Slide' ? '2013' : '2017';
      this.selectedEndDate = this.selectedDisasterType === 'Land Slide' ? '2016' : '2025';
    }
  }

  filterYearList() {
    const fullList = DISASTER_YEARLIST[this.selectedSourceType] || [];
    if (this.selectedSourceType === 'AGENTIC_HAZARD') {
      if (this.selectedDisasterType === 'Cyclone') {
        this.yearList = fullList.filter((y: any) => Number(y.value) >= 2017);
      } else if (this.selectedDisasterType === 'Land Slide') {
        this.yearList = fullList.filter((y: any) => Number(y.value) >= 2013);
      } else {
        this.yearList = fullList;
      }
    } else {
      this.yearList = fullList;
    }
  }
}
